<template>
  <v-app class="landing-shell landing-shell--light landing-shell--expanded">
    <Overlay :overlay="overlay" />
    <Snackbar :SnackBarComponent="SnackBarComponent" />

    <v-navigation-drawer
      permanent
      width="260"
      class="landing-shell__drawer"
    >
      <div class="landing-shell__dock-wrap">
        <div class="landing-shell__dock">
          <div class="landing-shell__dock-inner">
            <div class="landing-shell__brand">
              <img
                :src="brandLogoSrc"
                class="landing-shell__brand-logo"
                alt="Vozcare"
              />
            </div>

            <div class="landing-shell__nav-section">
              Navigation
              <span class="landing-shell__nav-count">{{ RouterList.length }}</span>
            </div>

            <div class="landing-shell__nav-viewport">
              <nav class="landing-shell__nav">
                <button
                  v-for="(item, idx) in RouterList"
                  :key="idx"
                  type="button"
                  class="landing-shell__nav-item"
                  :class="{ 'landing-shell__nav-item--active': item.active }"
                  @click="checkRouteMethod(item)"
                >
                  <span class="landing-shell__nav-icon-box">
                    <v-icon :icon="item.MenuICon" />
                  </span>
                  <span class="landing-shell__nav-label">{{ item.MenuName }}</span>
                </button>
              </nav>
            </div>

            <div class="landing-shell__dock-footer">
              <span class="landing-shell__status-dot"></span>
              <span>Workspace active</span>
            </div>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <v-app-bar class="landing-shell__appbar" elevation="0" height="58" flat absolute>
      <div class="landing-shell__appbar-left hidden-sm-and-down">
        <span class="landing-shell__page-chip">
          <v-icon :icon="activePageIcon" />
        </span>
        <div class="landing-shell__appbar-title">
          <span class="landing-shell__appbar-title-main">{{ activePageTitle }}</span>
          <span class="landing-shell__appbar-title-sub">Vozcare BMS</span>
        </div>
      </div>

      <v-spacer class="hidden-sm-and-down" />

      <div class="landing-shell__action-group">
        <div class="landing-shell__user-chip hidden-sm-and-down">
          <span class="landing-shell__avatar">{{ userInitial }}</span>
          <div class="landing-shell__user-meta">
            <span class="landing-shell__user-name">Admin</span>
            <span class="landing-shell__user-email">
              {{ $store.getters.get_user_email }}
            </span>
          </div>
        </div>

        <button
          type="button"
          class="landing-shell__logout-btn"
          @click="SignOut"
        >
          <v-icon icon="mdi-logout" />
          <span class="landing-shell__logout-label">Log out</span>
        </button>
      </div>
    </v-app-bar>

    <v-main>
      <div ref="home">
        <v-card
          class="elevation-0"
          @drop.prevent="onDrop($event)"
          @dragover.prevent="onDragOver($event)"
          @dragenter.prevent="dragover = true"
          @dragleave.prevent="onDragLeave($event)"
        >
          <router-view :vuetifyObj="vuetifyObj" v-if="dragover == false" />
          <v-card class="elevation-0" v-else :height="Height">
            <v-card
              fill-height
              fluid
              :height="`${Height - 120}`"
              class="elevation-0 borderDotted ma-8"
            >
              <v-container fill-height fluid>
                <v-row align="center" justify="center">
                  <v-col class="text-center">
                    <v-icon size="60px" color="primary"
                      >mdi-paperclip-plus</v-icon
                    >
                    <h2 class="mt-2">
                      Please Drag And Drop An Attachment To Report And Issue
                    </h2>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card>
        </v-card>
      </div>
    </v-main>
  </v-app>
</template>
<script>
import * as htmlToImage from "html-to-image";
import { signOut } from "@aws-amplify/auth";
import { useDisplay } from "vuetify/lib/composables/display";

import RouterList from "@/JsonFiles/RouterList.json";
import Overlay from "@/components/Extras/OverlayComp.vue";
import Snackbar from "@/components/Extras/SnackbarComp.vue";
import { GetCurrentUserDetailsQuery } from "@/mixins/GetCurrentUserDetailsQuery.js";

export default {
  components: {
    Overlay,
    Snackbar,
  },
  data: () => ({
    navDrawer: true,
    overlay: false,
    RouterList: [],
    selectedItem: 0,
    user_Status: null,
    dialogCreateIssue: false,
    dragover: false,
    Height: 0,
    selectedFilesFromDrop: [],
    vuetifyObj: {},
    SnackBarComponent: {},
  }),
  watch: {},
  computed: {
    brandLogoSrc() {
      return require("@/assets/vozcarelogo.png");
    },
    activeRouterItem() {
      return this.RouterList.find((o) => o.active) || null;
    },
    activePageTitle() {
      return this.activeRouterItem ? this.activeRouterItem.MenuName : "BMS";
    },
    activePageIcon() {
      return this.activeRouterItem
        ? this.activeRouterItem.MenuICon
        : "mdi-view-dashboard-outline";
    },
    userInitial() {
      const email = this.$store.getters.get_user_email || "";
      return email ? email.charAt(0).toUpperCase() : "A";
    },
  },
  mounted() {
    this.GetCurrentUserDetailsMethod();
    this.RouterList = [];
    this.vuetifyObj = useDisplay();
    for (let i = 0; i < RouterList.length; i++) {
      this.RouterList.push({ ...RouterList[i] });
    }
    this.$forceUpdate();
    if (this.$route.name !== "LandingPage") {
      const idx = this.RouterList.findIndex(
        (o) => o.MenuRoute === this.$route.name,
      );
      if (idx !== -1) {
        this.RouterList[idx].active = true;
      }
    }
    // this.router.push
  },
  mixins: [GetCurrentUserDetailsQuery],
  methods: {
    checkRouteMethod(item) {
      if (
        this.$route.name != item.MenuRoute &&
        item.has_child_routes == false
      ) {
        for (let i = 0; i < this.RouterList.length; i++) {
          if (item.MenuRoute == this.RouterList[i].MenuRoute) {
            this.RouterList[i].active = true;
          } else {
            this.RouterList[i].active = false;
          }
          if (this.$route.name != item.MenuRoute) {
            this.$router.push(item.MenuRoute);
          }
        }
      }
      this.$forceUpdate();
    },
    htmlToImageMethod() {
      this.overlay = true;
      this.$forceUpdate();
      this.selectedFilesFromDrop = [];
      var self = this;
      setTimeout(() => {
        htmlToImage.toBlob(this.$refs.home).then(function (blob) {
          blob.name = `ScreenShot${new Date().getTime()}.png`;
          self.selectedFilesFromDrop.push(blob);
          let object = {
            selectedFilesFromDrop: self.selectedFilesFromDrop,
            routeName: self.$route.name,
          };
          self.$store.commit("SET_ISSUE_DETAILS", object);
          self.$store.commit("SET_PREVIOUS_ROUTE", self.$route.name);
          self.$router.push("ReportIssue");
        });
      }, 2000);
    },
    dialogCreateIssueEmit(Toggle) {
      this.loading = false;
      this.dialogCreateIssue = false;
      this.selectedFiles = [];
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.$emit("clicked", Toggle);
    },
    async SignOut() {
      await signOut().then(() => {
        this.$router.push("/");
      });
    },
  },
};
</script>
<style src="@/assets/styles/landing-page-shell.css"></style>
